__turbopack_context__.v({
  "root": "mind-box-banner-container-module-scss-module__uaP9EG__root",
});
